import { Handle, Position } from "reactflow";
import { Shape } from "../shape";

export function EndForNode({data}: {data: string}) {
    
    return <Shape shapeType="diamond" width={90} height={70} selected={false} color="lightgreen">
        <Handle type="target" position={Position.Bottom} id={Position.Bottom}></Handle>
        <Handle type="target" position={Position.Top} id={Position.Top}></Handle>
        <Handle type="target" position={Position.Left} id={Position.Left}></Handle>
        <Handle type="target" position={Position.Right} id={Position.Right}></Handle>
        <Handle type="source" position={Position.Bottom} id={Position.Bottom}></Handle>
        <Handle type="source" position={Position.Top} id={Position.Top}></Handle>
        <Handle type="source" position={Position.Left} id={Position.Left}></Handle>
        <Handle type="source" position={Position.Right} id={Position.Right}></Handle>
        <span>
            (end for)
        </span>
    </Shape>
}